import { render, staticRenderFns } from "./orders-search.vue?vue&type=template&id=47738818&scoped=true"
import script from "./orders-search.vue?vue&type=script&lang=js"
export * from "./orders-search.vue?vue&type=script&lang=js"
import style0 from "./orders-search.vue?vue&type=style&index=0&id=47738818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47738818",
  null
  
)

export default component.exports